import APIService from 'api/APIService'
import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'

const useUnitBankInfo = () => {
  const { data: teamActiveCustomer } = useQuery({
    queryKey: ['unit', 'teamActiveCustomer'],
    queryFn: () => APIService.unit.unitGetCurrentUserActiveCustomer()
  })

  const unitAccount = useMemo(
    () => teamActiveCustomer?.unit_account,
    [teamActiveCustomer?.unit_account]
  )

  const { bankName, bankAddress, routingNumber, accountNumber, accountOwner } =
    useMemo(() => {
      return {
        bankName: unitAccount?.bank_name ?? '',
        bankAddress: unitAccount?.bank_address ?? '',
        accountOwner: unitAccount?.name ?? '',
        accountNumber: unitAccount?.account_number ?? '',
        routingNumber: unitAccount?.routing_number ?? ''
      }
    }, [unitAccount])

  return {
    bankName,
    bankAddress,
    routingNumber,
    accountNumber,
    accountOwner
  }
}

export default useUnitBankInfo
